import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NudgeLoginComponent } from './nudge-login.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    NudgeLoginComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [NudgeLoginComponent],
  bootstrap: [NudgeLoginComponent]
})
export class NudgeLoginModule { }
